import { CCard, CCardBody, CCardText, CCardTitle, CCol, CRow, CFormSelect } from '@coreui/react-pro'
import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import LineChart from './LineChart'
import './Dashboard.scss'
import moment from 'moment'
import { getPracticeOverview } from 'src/redux/dashboard/dashboardThunk'
import Loader from 'src/components/common/Loader/Loader'
import PropTypes from 'prop-types'

const PracticeOverview = ({ roles }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const rolesCondition = Boolean(
    roles.find((item) => item.groupname === 'Claimocity Provider Revenue'),
  )

  const [practiceOverviewFilter, setPracticeOverviewFilter] = useState('week')

  const patients = useSelector((state) => state.dashboard?.patients)
  const encounters = useSelector((state) => state.dashboard?.encounters)
  const revenue = useSelector((state) => state.dashboard?.revenue)
  const rvu = useSelector((state) => state.dashboard?.rvu)
  const isloading = useSelector((state) => state.dashboard?.isloading)

  const filter = async (type) => {
    setPracticeOverviewFilter(type)

    let currentDate = moment().format('YYYY-MM-DD')
    dispatch(getPracticeOverview({ currentDate, type }))
  }

  useEffect(() => {
    filter(practiceOverviewFilter)
  }, [])

  const handleNavigate = (type) => {
    navigate('/practiceIq', { state: { type, practiceOverviewFilter } })
  }

  return (
    <div className="practice-overview">
      {isloading && <Loader />}

      <CRow className="mt-5" style={{ minHeight: '40%' }}>
        <div className="practiceoverview-heading-container my-2">
          <div className="calendar-heading">Practice Overview</div>
          <div>
            <CFormSelect
              className="dashboard-details-select"
              onChange={(e) => filter(e.target.value)}
              value={practiceOverviewFilter}
            >
              <option className="filter-text" value={'year'}>
                In this Year
              </option>
              <option className="filter-text" value={'month'}>
                In this Month
              </option>
              <option className="filter-text" value={'week'}>
                In this Week
              </option>
            </CFormSelect>
          </div>
        </div>
        <CCol sm={rolesCondition ? '3' : '4'} className="mb-3">
          <CCard className="graph-card-overview ">
            <CCardTitle className="chart-text-graph mx-3 mt-3">
              Patients <p>{patients?.totalPatientCount}</p>
            </CCardTitle>
            <CCardText className="mx-3 text">
              {patients?.comparisonPercentage > 0 && '+'}
              {patients?.comparisonPercentage}% since last {practiceOverviewFilter}
            </CCardText>
            <CCardBody>
              <LineChart data={patients?.data} />
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={rolesCondition ? '3' : '4'} className="mb-3">
          <CCard className="graph-card-overview ">
            <CCardTitle className="chart-text-graph mx-3 mt-3">
              Encounters <p>{encounters?.totalencountersCount}</p>
            </CCardTitle>
            <CCardText className="mx-3 text">
              {encounters?.comparisonPercentage > 0 && '+'}
              {encounters?.comparisonPercentage}% since last {practiceOverviewFilter}
            </CCardText>
            <CCardBody>
              <LineChart data={encounters?.data} />{' '}
              <a
                className="seeall-link"
                onClick={() => {
                  handleNavigate('encounters')
                }}
              >
                See details
              </a>
            </CCardBody>
          </CCard>
        </CCol>
        {rolesCondition && (
          <CCol sm="3" className="mb-3">
            <CCard className="graph-card-overview ">
              <CCardTitle className="chart-text-graph mx-3 mt-3">
                Revenue <p>{revenue?.totalrevenueCount}</p>
              </CCardTitle>
              <CCardText className="mx-3 text">
                {revenue?.comparisonPercentage > 0 && '+'}
                {revenue?.comparisonPercentage}% since last {practiceOverviewFilter}
              </CCardText>
              <CCardBody>
                <LineChart data={revenue?.data} />
                <a
                  className="seeall-link"
                  onClick={() => {
                    handleNavigate('revenue')
                  }}
                >
                  See details
                </a>
              </CCardBody>
            </CCard>
          </CCol>
        )}

        <CCol sm={rolesCondition ? '3' : '4'} className="mb-3">
          <CCard className="graph-card-overview ">
            <CCardTitle className="chart-text-graph mx-3 mt-3">
              RVU <p>{rvu?.totalrvuCount}</p>
            </CCardTitle>
            <CCardText className="mx-3 text">
              {rvu?.comparisonPercentage > 0 && '+'}
              {rvu?.comparisonPercentage}% since last {practiceOverviewFilter}
            </CCardText>
            <CCardBody>
              <LineChart data={rvu?.data} />
              <a
                className="seeall-link"
                onClick={() => {
                  handleNavigate('rvu')
                }}
              >
                See details
              </a>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <div className="empty-prectice-overview"></div>
    </div>
  )
}

PracticeOverview.propTypes = {
  roles: PropTypes.array,
}

export default memo(PracticeOverview)
